<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 9.50036V12H2.49965L9.8719 4.62767L7.37229 2.12803L0 9.50036ZM11.805 2.69462C12.065 2.43466 12.065 2.01471 11.805 1.75475L10.2452 0.194972C9.98526 -0.0649908 9.56532 -0.0649908 9.30535 0.194972L8.08553 1.4148L10.5852 3.91445L11.805 2.69462Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#66B015'
    },
    width: {
      type: String,
      default: '12'
    },
    height: {
      type: String,
      default: '12'
    }
  },
  computed: {
    viewbox() {
      return `0 0 25 25`
    }
  }
}
</script>
